import type { ReactNode } from 'react';

export const symbol_massage: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m326-477 239 25 25-52-78-42-61-4q-13-1-21-10.5t-7-22.5q1-12 10-20t21-7l75 6 239 126q25 13 52.5 12.5T871-483L642-699H372l-73-104-143 67 87 201q11 26 33.5 41t49.5 17Zm-7 60q-44-5-79-30t-52-65l-86-200q-10-22-1.5-44.5T131-790l142-69q20-10 41-4t34 24l56 80h241q11 0 22 4.5t19 12.5l252 241q9 9 9 21.5t-9 21.5l-6 6q-39 38-91.5 45T740-426l-96-50-25 51q-9 17-25.5 26.5T558-391l-239-26ZM155-127q-12 3-22-3t-14-18q-4-12 2-23.5t19-14.5l174-43q78-20 155.5-35.5T628-280q68 0 130.5 23.5T875-191q9 8 9.5 19.5T877-151q-8 9-20.5 10t-22.5-7q-45-35-96.5-53.5T629-220q-80 0-156.5 16T319-169l-164 42Z"
		/>
	</svg>
);
